export default __webpack_public_path__ + "static/media/my_account.a2a06e87.svg";